const NoPermission = () => {
  return <h3 className="u-margin-top u-text-center">Je hebt momenteel de rechten niet om deze pagina te openen.</h3>;
};

export default NoPermission;
